(function () {

    'use strict';
    angular.module('app')
        .controller('appController', ['$scope', '$rootScope', '$location', '$timeout', 'angularLoad', 'accountsService', 'loginService', 'wowTrackingService', appController]
            );

    function appController($scope, $rootScope, $location, $timeout, angularLoad, accountsService, loginService, wowTrackingService) {
        $scope.scriptLoaded = false;
        $rootScope.loaded = false;
        $scope.model = {};
        $scope.model.isAuthenticated = false;
        $rootScope.warnAboutAuthenticator = false;
       

        $rootScope.$on('$routeChangeStart',
            function (event, next, current) {

                //if (current != undefined) {
                //    $rootScope.$broadcast('saveState', current.controller);
                //}

                //$rootScope.$broadcast('restoreState', next.controller);


                loadAuthenticatedAccount(next);


            });


        $scope.logOut = function () {
            loginService.logOut();

            $timeout(function () {
                $location.url('/');
            },
                501);
        };

        function loadAuthenticatedAccount(next) {


            accountsService.getAuthenticatedAccount().then(function (response) {
                $rootScope.loaded = true;
                    $scope.model = response;
                    $scope.model.isAdmin = (response.accountType === AccountType.Admin || response.accountType === AccountType.SuperAdmin);
                    $scope.model.isCompanyAdmin = response.accountType === AccountType.Company;
                    $scope.model.companyId = response.companyId;

                    $rootScope.warnAboutAuthenticator = (response.accountType === AccountType.Admin ||
                        response.accountType === AccountType.SuperAdmin ||
                        response.accountType === AccountType.Partner ||
                        response.accountType === AccountType.PartnerSuperAdmin) && !$scope.model.isGoogleAuthenticatorEnabled;

                    try {
                        wowTrackingService.trackPage($scope.model.email,
                            $scope.model.firstName,
                            $scope.model.lastName,
                            next.data.title,
                            $location.absUrl());
                    } catch (e) {

                    }

                    if (!$scope.scriptLoaded && ($location.url().toLowerCase() !== '/logout' && $location.url().toLowerCase() !== '/ssologout')) {
                     
                        var script = 'Plugin/scripts/gator_apps_plugin.js?accountId=' + $scope.model.accountId;
                        angularLoad.loadScript(script).then(function() {
                            $scope.scriptLoaded = true;
                            $scope.showLogo = false;
                            gatorAppsPlugin.init($, 'Gator.SignOn');
                        }).catch(function() {
                            // There was some error loading the script. Meh
                        });
                    }

                    if ($location.url() === '/') {
                        if (response.isAuthenticated) {

                            $location.url('/dashboard');

                        } else {
                            $rootScope.showLogo = true;
                            $location.url('/login');
                           
                        }
                    }


                });
        }
    }
})();